import _isEqual from 'lodash/isEqual';
import { hasItem } from '@sravni/ugc/lib/specialOffers/helpers';
import { INSURANCE_OFFERS, ACTIONS_LIST } from '@sravni/ugc/lib/specialOffers/lists';

const calculatePreloaderItemsCount = ({ activeTabType, insidePopup, isMobile, isNarrowOnDesktop, isVerticalOnMobile, maxDesktopVisibleItems, }) => {
    if (_isEqual(activeTabType, { type: INSURANCE_OFFERS.insuranceOsago }))
        return 1;
    if (insidePopup)
        return 4;
    if (isMobile) {
        return isVerticalOnMobile ? 3 : 4;
    }
    if (isNarrowOnDesktop) {
        return 3;
    }
    if (activeTabType && hasItem(ACTIONS_LIST, activeTabType)) {
        return 4;
    }
    return maxDesktopVisibleItems || 8;
};

export { calculatePreloaderItemsCount };
//# sourceMappingURL=calculatePreloaderItemsCount.js.map
